import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterStateSnapshot } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HubModule } from '../../hub/hub.module';
import { PerfilModule } from '../../perfil/perfil.module';
import { BloquearPantallaModule } from '../../bloquear-pantalla/bloquear-pantalla.module';
import { VentaRoutingModule } from './venta-routing.module';
import { PaginacionModule } from '../../parcial/paginacion/paginacion.module';

import { PipesModule }             from '../../pipes/pipes.module';
import { OtrosPagosComponent } from './formulario/formulario.component';
import { DevolucionComponent } from './formulario/devolucion.component';
import { OtrosPagosListaComponent } from './otros-pagos-lista/lista.component';
import { ListaComponent } from './lista/lista.component';

import { AuthService } from '../../auth.service';

import { MenuModule } from '../../menu/menu.module';
import { ParcialModule } from '../../parcial/parcial.module';

//crud
import { CrudService } from '../../crud/crud.service';
import { CrudModule } from '../../crud/crud.module';
//fin crud

import { NgSelect2Module } from 'ng-select2';
import { NguiAutoCompleteModule } from '@ngui/auto-complete';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    VentaRoutingModule,
    HubModule,
    PerfilModule,
    BloquearPantallaModule,
    PaginacionModule,
    PipesModule,
    MenuModule,
    ParcialModule,
    NgSelect2Module,
    NguiAutoCompleteModule,
    
    CrudModule
  ],
  declarations: [
    OtrosPagosComponent,
    DevolucionComponent,
    OtrosPagosListaComponent,
    ListaComponent
  ],
  exports:[
    OtrosPagosComponent,
    OtrosPagosListaComponent
  ],
  providers: [ AuthService, CrudService ]
})
export class VentaModule { }
